// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const TransactionSource = {
  Web: {
    Name: 'Web',
    Value: 'web',
  },
  POS: {
    Name: 'POS',
    Value: 'pos',
  },
  External: {
    Name: 'External',
    Value: 'external',
  },
  Internal: {
    Name: 'Internal',
    Value: 'internal',
  },
} as const

export type TransactionSourceValue =
  (typeof TransactionSource)[keyof typeof TransactionSource]['Value']
